/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import React, { FunctionComponent, useEffect } from 'react';

import { BrandingUiInfoKeys } from '../../../../core/entities';
import { ServicesClientImpl } from '../../../../core/interactors';
import { Locale, LocaleKeys } from '../../../../core/locale';
import { BrandingUiUtility } from '../../../../core/utils';
import { SettingsTemplate } from '../../SettingsTemplate';

import '../../SettingsCommon.scss';
import { KeyManager } from '../../../../core/navigation';

const defaultServices = new ServicesClientImpl();

const ForgottenPin: FunctionComponent = () => {
    const rawText = Locale.getString(LocaleKeys.SETTINGS_HELP_PC_FORGOTTEN_PIN);
    const text = BrandingUiUtility.formatDescription(rawText, {
        CUSTOMER_SUPPORT_NAME: defaultServices.getBrandingUiInfoForKey(
            BrandingUiInfoKeys.CUSTOMER_SUPPORT_NAME,
        ),
        PHONE_CUSTOMER_SUPPORT_NUMBER: defaultServices.getBrandingUiInfoForKey(
            BrandingUiInfoKeys.PHONE_CUSTOMER_SUPPORT_NUMBER,
        ),
    });

    useEffect(() => {
        const keyManagerIns: KeyManager = KeyManager.getInstance();
        if (keyManagerIns.isKeyIgnoring()) {
            keyManagerIns.stopKeyIgnoring();
        }
    }, []);

    return (
        <SettingsTemplate title={Locale.getString(LocaleKeys.PC_HELP_SCREEN_FORGOTTEN_TITLE)}>
            <div className="settings-common-content text-content">{text}</div>
        </SettingsTemplate>
    );
};

export default ForgottenPin;
